import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    html: {
        titlePage: "Mon compte",
        identityTitle: "Identité",
        myProfileTitle: "Mon profil",
        myCompanyTitle: "Mon entreprise",
        companyDescription: "Gérez votre entreprise",
        myCalendarTitle: "Mes disponibilités",
        myRelationsTitle: "Mes relations",
        relations: "Partagez votre emploi du temps à vos proches",
        connectionTitle: "Connexion",
        myPhoneNumberTitle: "Numéro de téléphone",
        myMailTitle: "Adresse mail",
        calendarDescription: "Informez vos relations de vos horaires et disponibilités",
        myProTitle: "Mes professionnels",
        pro: "Ajoutez et gérez votre annuaire et facilitez la prise de rendez vous avec vos pros"
    },

    profilePicture: "Photo de profil",

    profileDialog: {
        title: "Modifier mon profil",
        save: "Sauvegarder",
        cancel: "Fermer"
    },

    phoneNumberDialog: {
        title: "Modifier mon numéro de téléphone",
        save: "Sauvegarder",
        cancel: "Fermer"
    }
};

export type I18nProfile = typeof _fr;

const _en: I18nProfile = {
    html: {
        titlePage: "My account",
        identityTitle: "Identity",
        myProfileTitle: "My profile",
        myRelationsTitle: "My relations",
        relations: "Share your schedule with friends and family",
        connectionTitle: "Connection",
        myPhoneNumberTitle: "Phone number",
        myMailTitle: "E-mail address",

        myCompanyTitle: "My company",
        companyDescription: "Manage your company",

        myCalendarTitle: "My availability",
        calendarDescription: "Inform your contacts of your schedule and availability",
        pro: "Add and manage your directory and make it easier to make appointments with your professionals",
        myProTitle: "My professionals"
    },
    profilePicture: "Profile picture",

    profileDialog: {
        title: "Modify your profile",
        save: "Save",
        cancel: "Cancel"
    },

    phoneNumberDialog: {
        title: "Change my phone number",
        save: "Save",
        cancel: "Cancel"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nProfile {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}